export {default as HiristJobDetailSkeleton} from './HiristJobDetailSkeleton';
export {default as IimjobsJobDetailSkeleton} from './IimjobsJobDetailSkeleton';
